var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85355 2.14646L3.5 1.79291L3.14645 2.14646L0.146447 5.14646C-0.0488156 5.34172 -0.0488156 5.65831 0.146447 5.85357C0.341709 6.04883 0.658291 6.04883 0.853553 5.85357L3 3.70712V15.5C3 16.8807 4.11929 18 5.5 18H10.5C10.7761 18 11 17.7762 11 17.5C11 17.2239 10.7761 17 10.5 17H5.5C4.67157 17 4 16.3284 4 15.5V3.70712L6.14645 5.85357C6.34171 6.04883 6.65829 6.04883 6.85355 5.85357C7.04882 5.65831 7.04882 5.34172 6.85355 5.14646L3.85355 2.14646ZM16.1464 17.8536L16.5 18.2071L16.8536 17.8536L19.8536 14.8536C20.0488 14.6583 20.0488 14.3417 19.8536 14.1465C19.6583 13.9512 19.3417 13.9512 19.1464 14.1465L17 16.2929V4.50001C17 3.1193 15.8807 2.00001 14.5 2.00001H9.5C9.22386 2.00001 9 2.22387 9 2.50001C9 2.77616 9.22386 3.00001 9.5 3.00001H14.5C15.3284 3.00001 16 3.67159 16 4.50001V16.2929L13.8536 14.1465C13.6583 13.9512 13.3417 13.9512 13.1464 14.1465C12.9512 14.3417 12.9512 14.6583 13.1464 14.8536L16.1464 17.8536Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.0deaace75f3ec85827aeabc934d06ad5.svg";
export { ForwardRef as ReactComponent };